import { spinnerTypes } from '../actions/types'

const initialState = {
    count: 0,
    loading: false,
}

export const spinnerReducer =
    (
        state = initialState,
        action
    ) => {
        switch (action.type) {
            case spinnerTypes.SHOW:
                return {
                    ...state,
                    count: state.count + 1,
                    loading: true,
                }
            case spinnerTypes.HIDE:
                let count = state.count - 1

                return {
                    ...state,
                    count: count,
                    loading: !!count,
                }
            default:
                return state
        }
    }